// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS general definition */
:root {
    ::-webkit-scrollbar {
        width: var(--ds-xs);
        height: var(--ds-xs);
        background-color: transparent;
    }

    ::-webkit-scrollbar-thumb {
        width: var(--ds-xs);
        height: var(--ds-xs);
        background-color: var(--ds-scrollbar-thumb-bg-color);
        border-radius: var(--ds-border-radius-xs);
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
